import { makeStyles } from "@material-ui/core/styles";

export function useAttendanceLocalMapStyles() {
    const useStyles = makeStyles((theme) => ({
        button: {
            color: "#004B97",
            fontSize: "0.95rem",
            fontWeight: 500,
            "&:hover": {
                backgroundColor: "transparent",
            },
        },
        cardHeader: {
            color: "#fff",
            backgroundColor: "#004B97",
        },
        cardContent: {
            minWidth: 600,
            display: "flex",
            gap: theme.spacing(2),
            padding: theme.spacing(2),
            flexDirection: "column",
            alignItems: "center",
        },
        cardActions: {
            justifyContent: "flex-end",
            borderTop: "1px solid #F0F0F0",
        },
        paper: {
            padding: '8px',
            position: 'relative',
            backgroundColor: 'rgba(51, 51, 51, 0.9)',
            borderRadius: '8px',
            boxShadow: theme.shadows[0],
            maxWidth: 200,
        },
        typography: {
            color: "#FFF",
            fontWeight: 500,
            fontSize: theme.typography.pxToRem(13),
        },
        arrow: {
            width: 0,
            height: 0,
            position: 'absolute',
            borderLeft: '5px solid transparent',
            borderRight: '5px solid transparent',
            borderTop: '5px solid rgba(0, 0, 0, 0.8)',
            bottom: '-5px',
            left: '50%',
            transform: 'translateX(-50%)'
        }
    }));

    const classes = useStyles();

    return {
        classes,
    };
}
